module.exports = __webpack_public_path__ + "static/media/HonedLogo-01.ec1bfecf.svg";